import { ChangeEvent, useEffect, useState } from "react";
import { baseURL } from "../../api/Api";
import "../../container/styles.css";
import ApiService from "../../api/ApiServices";
import ChallengeSuccessModalProps from "../ChallengeSuccessModal";
import AlertModal from "../AlertModal";

const HomeScrollPicFragment = ({
  onClick,
  hideOptions = false,
  imgStyle = null,
  contStyle = null,
  id,
  picUrl,
  handleSuccess,
  handleReadMore,
  data,
  onCompleted,
  skipAvailabilityCheck = false,
  isChallengeCompleted,
}: {
  onClick?: React.MouseEventHandler<HTMLDivElement> | undefined;
  hideOptions?: boolean;
  imgStyle?: any;
  contStyle?: any;
  id?: any,
  picUrl?: any,
  handleSuccess?: any,
  handleReadMore?: any;
  data?: any,
  onCompleted?: any,
  skipAvailabilityCheck?: boolean,
  isChallengeCompleted?: boolean,
}) => {
  const [localChallengeCompleted, setLocalChallengeCompleted] = useState<boolean>(false);
  const resolvedIsChallengeCompleted = Boolean(isChallengeCompleted || localChallengeCompleted);
  const [uploading, setUploading] = useState<boolean>(false);
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("Challenge completed");
  const [successResponse, setSuccessResponse] = useState<any>(null);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>("");

  const openAlert = (message: string) => {
    setAlertMessage(message);
    setShowAlert(true);
  };

  const checkChallengeCompleted = async (challengeId: string) => {
    try {
      const availableResponse = await ApiService.getAvailableChallenges();
      const availableChallenges = availableResponse?.data || [];
      const isAvailable = availableChallenges?.some((item: any) => {
        const availableId = item?._id || item?.challengeId?._id || item?.challengeId;
        return availableId === challengeId;
      });
      setLocalChallengeCompleted(!isAvailable);
    } catch (error) {
      setLocalChallengeCompleted(false);
    }
  };

  useEffect(() => {
    if (typeof isChallengeCompleted === "boolean") {
      return;
    }

    if (skipAvailabilityCheck) {
      setLocalChallengeCompleted(false);
      return;
    }

    if (id) {
      checkChallengeCompleted(id);
    }
  }, [id, skipAvailabilityCheck, isChallengeCompleted]);
  const updatePicQuiz = async (profile: string) => {
    try {
      const response = await ApiService.answerText({
        challengeId: id,
        answer: profile,
      });
      if (response?.status) {
        setSuccessMessage(response?.message || "Challenge completed");
        setSuccessResponse(response);
        setShowSuccessModal(true);
        setLocalChallengeCompleted(true);
      }
    } catch (error) {
      console.error("Error while updating user profile", error);
    } finally {
      setUploading(false);
    }
  }
  function handleFileUpload(event: ChangeEvent<HTMLInputElement>) {
    if (resolvedIsChallengeCompleted) return;
    const files = event.target.files;
    if (!files || files.length === 0) {
      return;
    }
    const file = files[0];
    const formData = new FormData();
    formData.append('file', file);
    setUploading(true);

    fetch(`${baseURL}/upload`, {
      method: 'POST',
      body: formData
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to upload file');
        }
        return response.json();
      })
      .then(data => {
        updatePicQuiz(data?.data)
      })
      .catch(error => {
        openAlert(error?.message || "Error uploading file.");
        setUploading(false);
      });      
  }
  return (
    <>
      <AlertModal
        visible={showAlert}
        title="Error"
        message={alertMessage}
        onConfirm={() => setShowAlert(false)}
      />
      <ChallengeSuccessModalProps
        visible={showSuccessModal}
        message={successMessage}
        onConfirm={() => {
          setShowSuccessModal(false);
          onCompleted && onCompleted();
          handleSuccess && handleSuccess(successResponse);
        }}
      />
      <div
        onClick={onClick}
        className={`flex flex-col flex-1 home-frag-cont relative ${!hideOptions && `mr-3`
          }
        ${contStyle && contStyle}
        `}
      >
        {data?.additionalInfo !== "" && <button
          className="absolute top-3 right-4 text-sm font-bold h-8 w-8 text-black readmore-btn"
          onClick={() => handleReadMore(data?.additionalInfo)}
        >
          ?
        </button>}
        <img
          alt=""
          className={`home-frag-img ${imgStyle}`}
          src={picUrl || require("../../assets/homeFragPic.png")}
        />
        {!hideOptions && !resolvedIsChallengeCompleted && (
          <div className="absolute left-0 right-0 bottom-4">
            <div className="flex flex-row flex-1 justify-center ">
              <label htmlFor={`file-upload-${id}`} className={`secondary-btn px-4 py-4 ${resolvedIsChallengeCompleted || uploading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}>
                <img
                  src={require("../../assets/camera.png")}
                  className="home-frag-pic-img"
                  alt=""
                />
              </label>
              <input accept=".png, .jpg, .jpeg" id={`file-upload-${id}`} type="file" className="hidden" onChange={handleFileUpload} />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default HomeScrollPicFragment;
